import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../colorVars';
import { Body2 } from '../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../alertFormClass';
import style from './SetupField.module.css';

export const SetupField = observer(() => {
  const form = useAlertFormStore();
  return (
    <div className={style.container}>
      <Body2 color={colors.lightGrey} fontWeight={700}>
        Setup
      </Body2>
      <select
        className={style.select}
        value={form.setup}
        onChange={({ target }) => form.setSetup(target.value)}
      >
        <option value="default">Select a setup...</option>
        <option value="CANDLE_PATTERN">Candle Pattern</option>
        <option value="CANDLE_TRIGGER">Candle Trigger</option>
        <option value="BREAK">Break</option>
        <option value="BOUNCE">Bounce</option>
        <option value="ORB">ORB</option>
      </select>
    </div>
  );
});
